import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { ConfigBuilderService } from '@app/services/config-builder.service';
import { ToastService } from '@app/services/toast.service';
import { Messages as msg } from '@app/src/util/messages.util';

@Component({
  selector: 'app-input-args-parent',
  templateUrl: './input-args-parent.component.html',
  styleUrls: ['./input-args-parent.component.scss']
})
export class InputArgsParentComponent implements OnInit {

  // Variables
  issueTmplList: any[] = []; // List of issue templates
  issueTmpInp: any[] = []; // Inputs for the selected issue template
  checkboxValue: any = false; // Checkbox value boolean

  // Input properties
  @Input() mode: any; // 'view' or 'add' or 'edit'
  @Input() workflowDtls: any; // repoUrl and branch name
  @Input() onExpand: any; // Object containing workflow details and issue template id when expanded

  // Output properties
  @Output() isIssueTmplChecked = new EventEmitter<boolean>(); // Emit the checkbox value to parent component
  @Output() issueTmpInputs = new EventEmitter<any>(); // Emit the issue template inputs and issue template id to parent component

  // ViewChild references
  @ViewChild('checkbox') checkbox: MatCheckbox // Reference to the checkbox
  @ViewChild('issueTmpSelect') issueTmpSelect: any // Reference to the issue template select dropdown

  /**
   * Constructor
   * @param cb ConfigBuilderService instance to handle API calls
   * @param ts ToastService instance to show toast messages
   */
  constructor(private cb: ConfigBuilderService,
    private ts: ToastService) {

  }

  /** ngOnInit */
  ngOnInit() {
  }

  /**
   * ngOnChanges
   * @param changes SimpleChanges - Detect changes in input properties
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['onExpand']) {
      this.viewMode();
    }
  }

  /**
   * viewMode is used to set the checkbox value and fetch issue templates when the component is in view mode
   * It also sets the issue template select dropdown value based on the issue template id
   */
  viewMode() {
    if (this.onExpand?.issueTempId) {
      this.checkboxValue = !this.checkboxValue;
      this.checkbox.checked = true; // Set checkbox value to true
      this.isIssueTmplChecked.emit(this.checkboxValue);

      // Fetch issue templates from the workflow details
      this.getIssueTmpl(this.onExpand?.wfhRepoUrl, this.onExpand?.wfhBranch).then(() => {
        // Set the issue template select dropdown value based on the issue template id
        const issueTemplate = this.issueTmplList.find((template) => template.id === this.onExpand?.issueTempId);
        if (issueTemplate) {
          this.issueTmpSelect.value = issueTemplate.id;
        }
      });
    }
  }

  /**
   * onCheckboxChange is used to handle the checkbox change event
   * It toggles the checkbox value and fetches issue templates if the checkbox is checked
   * @param event Checkbox change event
   */
  onCheckboxChange(event: any) {
    this.checkboxValue = !this.checkboxValue; // Toggle checkbox value
    //  if checkboxValue is true, fetch issue templates from the workflow details
    if (this.checkboxValue) {
      Object.keys(this.onExpand).length > 0 ? this.getIssueTmpl(this.onExpand?.wfhRepoUrl, this.onExpand?.wfhBranch) : this.getIssueTmpl(this.workflowDtls[0], this.workflowDtls[1]);
    }

    // if checkboxValue is false, reset the issue template select dropdown
    if (!event.checked && this.issueTmpSelect.value) {
      this.issueTmpSelect.value = null;
    }
    this.isIssueTmplChecked.emit(this.checkboxValue); // Emit the checkbox value to parent component
  }

  /**
   * onDropdownSelect is used to handle the issue template select dropdown change event
   * It fetches the issue template inputs based on the selected issue template id
   * @param event Dropdown change event
   */
  onDropdownSelect(event: any) {
    if (event && event.value) {
      this.getIssueTmplComp(event.value);
    }
  }

  /**
   * Fetch issue templates from the backend based on repository URL and branch name
   * @param repoUrl Repository URL
   * @param branchName Branch name
   * @returns Promise resolving to the list of issue templates
   */
  getIssueTmpl(repoUrl: string, branchName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.issueTmplList = [];  // Reset issue template list

      this.cb.getIssueTmplList(repoUrl, branchName).subscribe((resp: any) => {
        if (resp?.data?.dbResp && resp?.data?.dbResp.length > 0) {
          this.issueTmplList = resp?.data?.dbResp || [];  // Set issue template list from response
        } else {
          this.issueTmplList = [];  // Reset issue template list
        }
        resolve(this.issueTmplList); // Resolve the promise with the issue template list
      }, (err: any) => {
        this.ts.showError(msg.failed, msg.issueTmplate.getissueTmpFail);
        reject(err); // Reject the promise with error
      })
    });
  }

  /**
   * Fetch issue template components based on the selected issue template id
   * @param id Issue template id
   */
  getIssueTmplComp(id: number) {
    this.cb.getIssueTmplComp(id).subscribe((resp: any) => {
      if (resp) {
        this.issueTmpInp = resp?.data?.dbResp[0]?.comp?.details || [];  // Set issue template inputs from response
        this.issueTmpInputs.emit({ issueTmplInp: this.issueTmpInp, id: id }); // Emit the issue template inputs and id to parent component
      }
    }, (err: any) => {
      this.ts.showError(msg.failed, msg.issueTmplate.getissueTmpInpFail);
    })
  }
}
